import React, { useContext } from "react";
import { QuizContext } from "../../App";
// import submitLogOut from "../../reducer/actions/userActions/SubmitLogOut";
// import { Link } from "react-router-dom";
// import Badge from 'react-bootstrap/Badge';

const TextUserHeader = () => {

  const quizContext = useContext(QuizContext);

  // const alertStatus = "log out";
  const date = new Date(quizContext.state.currentUser.joined_at);
  const year = date.getFullYear();
  const monthName = date.toLocaleString('en-US', { month: 'long' });
  const score = quizContext.state.createdQuizzes.length
    ? quizContext.state.createdQuizzes[0].score
    : 0;

  const userMembPlan = quizContext.state.currentUser.mem === "ADM"
    ? "ADMIN"
    : quizContext.state.currentUser.mem === "STU"
      ? "STUDENT"
      : quizContext.state.currentUser.mem === "BRZ"
        ? "BRONZE"
        : quizContext.state.currentUser.mem === "SLV"
          ? "SILVER"
          : quizContext.state.currentUser.mem === "GLD"
            ? "GOLD"
            : quizContext.state.currentUser.mem === "GURU"
              ? "GURU"
              : "STANDARD"


  return (
    <>
      <h2 className="header">
        {quizContext.state.currentUser.username}
      </h2>
      <p>
        ID: <span style={{ fontWeight: "600" }}>{quizContext.state.currentUser.id}</span><br />
        Joined in <span style={{ fontWeight: "600" }}>{monthName} {year}</span><br />
        Contribution Rating: <span style={{ fontWeight: "600" }}>{score}</span><br />
        Membership Plan: <span style={{ fontWeight: "600" }}>{userMembPlan}</span>
      </p>
    </>
  )
}

export default TextUserHeader